
import { initScrollClasses, initModal, initAfterInteract } from "./functions/core";
import { initDatalayer, readCookiePermissions, readCookie } from "./functions/cookies/core";
import { validateFormBootstrap } from "./functions/forms/validation";

import { initJquery } from "./functions/initializers/jquery";
import { initSelect2 } from "./functions/initializers/select2";
import { initDatepicker } from "./functions/initializers/datepicker";
import { toggleCollapseOnParent } from "./functions/initializers/parent-collapse";
import { initTimepicker } from "./functions/initializers/timepicker";
import { initSwiper } from "./functions/initializers/swiper";
import { initMarquee } from "./functions/initializers/marquee";
import { initFileInput } from "./functions/initializers/file-input";
import { initCookiesBox } from "./functions/initializers/cookie-box";
import { initBootstrap } from "./functions/initializers/bootstrap";

// Add functions to the global window object to give access to backend devs
document.addEventListener("DOMContentLoaded", async () => {
	console.log("Developed by LOBA - https://www.loba.com/");

	//=== Core ===//

	initScrollClasses('.header')
	window.initModal = initModal;

	//=== Cookies ===//

	initDatalayer()
	readCookiePermissions('loba_')
	window.readCookie = readCookie;
	window.initCookiesBox = initCookiesBox;

	Promise.all([
		// Swiper
		initSwiper('.swiper'),
		// Custom Marquee
		initMarquee('.marquee'),
		// Allow collapse to toggle a classe on any parent element
		toggleCollapseOnParent(),
		//=== Bootstrap ===//
		initBootstrap({
			'critical': ["initCollapse"] // Collapse is critical for the menu, everything else can be lazy loaded in most cases
		})
	]).then(() => {
		const swiper = new Swiper('.swiperHomepage', {
			direction: 'horizontal',
			slidesPerView: 1,
			speed: 1000,
			createElements: true,
			scrollbar: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
					return '<div class="' + className + '"><span class="count">' + numbersBulletLabels[index] + '</span><span class="text-bullet">' + bulletLabels[index] + '</span></div>';
				}
			}
		});

		window.initDatepicker = initDatepicker
	})

	//=== Non-Critical Functions ===//

	Promise.all([
		initAfterInteract([
			// Datepicker
			() => initDatepicker('.datepicker-input'),
			// Timepicker
			() => initTimepicker('.timepicker-input'),
			// File Input
			() => initFileInput(".custom-file input"),
		])
	]).then(() => {
		window.initTimepicker = initTimepicker
		window.initFileInput = initFileInput;
	})

	//=== Forms ===//

	validateFormBootstrap(".needs-validation")
});


initJquery().then(() => {
	function runWhenDOMReady() {
		// jQuery dependant code should be placed here

		//=== Select2 ===//
		initSelect2('.custom-select-option select')
		window.initSelect2 = initSelect2;
	}

	if (document.readyState === 'interactive' || document.readyState === 'complete') { runWhenDOMReady(); } else { document.addEventListener('DOMContentLoaded', runWhenDOMReady); }
})

//OpenMenu and Close Mobile

document.addEventListener('DOMContentLoaded', function () {
	const openBtn = document.querySelector('.openMobileMenu');
	const closeBtn = document.querySelector('.closeMobileMenu');
	const mobileMenu = document.querySelector('.menu-mobile');

	openBtn.addEventListener('click', function () {
		mobileMenu.classList.add('active');
		document.body.style.overflow = 'hidden';
	});

	closeBtn.addEventListener('click', function () {
		mobileMenu.classList.remove('active');
		document.body.style.overflow = '';
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const voltarBtn = document.querySelector(".btn-voltar a");
	if (voltarBtn) {
		voltarBtn.addEventListener("click", function (e) {
			e.preventDefault();
			history.back();
		});
	}
});

if (document.getElementById('tabAbout')) {
	document.querySelectorAll('#tabAbout button[data-bs-toggle="tab"]').forEach((tabButton) => {
		tabButton.addEventListener('shown.bs.tab', function (event) {
			const selectedId = event.target.getAttribute('data-bs-target').replace('#', ''); // ex: tab_0
			const imageTabId = selectedId.replace('tab_', 'img_'); // ex: img_0

			// Remover classe ativa das imagens
			document.querySelectorAll('#tabAboutContentImage .tab-pane').forEach((pane) => {
				pane.classList.remove('show', 'active');
			});

			// Ativar a imagem correspondente
			const targetPane = document.querySelector(`#tabAboutContentImage #${imageTabId}`);
			if (targetPane) {
				targetPane.classList.add('show', 'active');
			}
		});
	});
};

document.addEventListener("DOMContentLoaded", () => {
	const timeline = document.querySelector(".timeline");
	if (!timeline) return;

	const line = document.querySelector(".timeline-line");
	const fill = document.querySelector(".timeline-line-fill");
	const items = document.querySelectorAll(".timeline-item");

	// Define offset para bolinhas baseado na largura da janela
	function getBreakpointOffset() {
		const width = window.innerWidth;
		if (width < 768) return 340;
		if (width < 990) return 535;
		return 60;
	}

	const FIXED_ACTIVE_OFFSET = 60; // offset fixo para active/opacity

	// Criar bolinhas com offset baseado em breakpoints
	items.forEach(item => {
		const dot = document.createElement("div");
		dot.classList.add("timeline-dot");

		const offset = getBreakpointOffset();
		const offsetTop = item.offsetTop + offset;
		dot.style.top = `${offsetTop}px`;
		line.appendChild(dot);
	});

	const update = () => {
		const scrollY = window.scrollY || window.pageYOffset;
		const windowMiddle = scrollY + window.innerHeight / 2;

		const timelineTop = timeline.offsetTop;
		const timelineHeight = timeline.offsetHeight;
		const maxFillHeight = Math.min(windowMiddle - timelineTop, timelineHeight);
		fill.style.height = Math.max(0, maxFillHeight) + "px";

		const dots = document.querySelectorAll(".timeline-dot");

		items.forEach((item, index) => {
			const dot = dots[index];
			const dotTop = parseFloat(dot.style.top);

			// Preenche bolinha se linha passou por ela
			if (dotTop <= maxFillHeight) {
				dot.classList.add("filled");
			} else {
				dot.classList.remove("filled");
			}

			// Ativa item com offset fixo de 60px
			const itemTopInViewport = item.getBoundingClientRect().top;
			if (itemTopInViewport <= window.innerHeight / 2 - FIXED_ACTIVE_OFFSET) {
				item.classList.add("active");
			} else {
				item.classList.remove("active");
			}
		});
	};

	window.addEventListener("scroll", update);
	window.addEventListener("resize", () => location.reload()); // atualiza bolinhas ao mudar largura
	update();
});

document.addEventListener("DOMContentLoaded", function () {
	const btUpload = document.querySelector(".bt-upload");
	if (!btUpload) return; // Se não existir .bt-upload, encerra o script

	const inputFile = document.getElementById("curriculo-contacto");
	const nameFileDisplay = btUpload.querySelector(".name-file");

	inputFile.addEventListener("change", function () {
		if (inputFile.files.length > 0) {
			nameFileDisplay.textContent = inputFile.files[0].name;
		} else {
			nameFileDisplay.textContent = "Selecionar um ficheiro";
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector(".is-black-header")) {
		document.body.classList.add("header-black");
	}
});

if (document.querySelector('.cronometro-animation')) {
	function animateCounter(element, target, prefix = '', suffix = '') {
		const duration = 2000;
		const startTime = performance.now();

		function update(currentTime) {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const current = Math.floor(progress * target);

			element.textContent = prefix + current + suffix;

			if (progress < 1) {
				requestAnimationFrame(update);
			} else {
				element.textContent = prefix + target + suffix;
			}
		}

		requestAnimationFrame(update);
	}

	function initCounters() {
		const items = document.querySelectorAll('.resultado-item h3');
		items.forEach((el) => {
			const target = parseInt(el.getAttribute('data-target'), 10);
			const prefix = el.getAttribute('data-prefix') || '';
			const suffix = el.getAttribute('data-suffix') || '';
			animateCounter(el, target, prefix, suffix);
		});
	}

	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				initCounters();
				obs.disconnect();
			}
		});
	});

	observer.observe(document.querySelector('.grid-resultados'));




   
}

document.addEventListener('DOMContentLoaded', function() {
    const submenuToggles = document.querySelectorAll('.submenu-toggle');
    
    submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Remove active class from all toggles
            submenuToggles.forEach(t => t.classList.remove('active'));
            
            // Hide all submenus
            document.querySelectorAll('.submenu-mobile').forEach(sub => {
                sub.style.display = 'none';
            });
            
            // Add active class to clicked toggle
            this.classList.add('active');
            
            // Show target submenu
            const targetId = this.getAttribute('data-target');
            const targetSubmenu = document.getElementById(targetId);
            if (targetSubmenu) {
                targetSubmenu.style.display = 'block';
            }
        });
    });
});